import React from "react";
import { Link } from "react-router-dom";
import karwan from "../images/karvaan.jpg";
import { Button } from "../button";
const Navbar = ({ toggleTheme,isAuthor, isContact, isAbout, isHome, handleLogout, finalizeCart }) => {
  const renderLinks = () => {
    if (isHome) {
      return (
        <>
          <Link to="/about" className="navbar-link">About</Link>
          <Link to="/author" className="navbar-link">Authors</Link>
          <Link to="/contact" className="navbar-link">Contact</Link>
        </>
      );
    } else {
      return (
        <>
          <Link to="/home" className="navbar-link">Home</Link>
          {!isAbout && <Link to="/about" className="navbar-link">About</Link>}
          {!isAuthor && <Link to="/author" className="navbar-link">Authors</Link>}
          {!isContact && <Link to="/contact" className="navbar-link">Contact</Link>}
        </>
      );
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src={karwan} alt="Logo" className="navbar-logo" />
      </div>
      <div className="navbar-center">
        {renderLinks()}
      </div>
      <div className="navbar-right">
        <Button onClick={toggleTheme}>Theme</Button>
        {finalizeCart && <button className="navbar-button" onClick={finalizeCart}>Cart</button>}
        {handleLogout && <button className="navbar-button" onClick={handleLogout}>Logout</button>}
      </div>
    </nav>
  );
};

export default Navbar;
